module.exports = __webpack_public_path__ + "img/planningOFF.b47ced52.png";